// src/config/landing.config.js

const landingConfig = {
    siteName: "BBTS",
    siteTitle: "BBTS | Soluciones que funcionan",
    logo: "/logo-bbts.png",
    whatsappPhone: "15558364840",
    whatsappMessage: "Hola BBTS, quiero una propuesta para mi negocio",
    googleTagId: "AW-16987830296",
    redirectUTM: "google",
    redirectWhatsAppLink:
      "https://wa.me/15558364840?text=Hola%20BBTS%2C%20quiero%20una%20propuesta%20para%20mi%20negocio",
  
      hero: {
        title: "Tecnología que cobra, vende y hace crecer tu negocio",
        subtitle:
          "Somos una compañía puertorriqueña especialista en Clover y desarrollo a la medida. Integramos pagos, creamos apps para ordenar y entregar comida, y conectamos cada parte de tu operación para que vendas más y trabajes menos.",
        bullets: [
          "Integración de múltiples métodos de pago en tu sistema",
          "Expertos certificados en plataforma Clover",
          "Apps personalizadas para ordenar comida y delivery",
          "eCommerce conectado a tu POS y tu inventario",
          "Automatización de procesos (facturas, recibos, cotizaciones)",
          "Digital signage y menús dinámicos en pantallas",
          "Sistema de nómina y control de empleados",
          "Cuadros telefónicos digitales (IVR) y reservaciones con QR"
        ],
        cta: "Conecta tu negocio con el futuro"
      },
      
  
    servicesTitle: "Soluciones que construimos para ti",
    services: [
      {
        src: "/clover.png",
        title: "POS Clover y eCommerce",
        desc: "Soluciones personalizadas sobre Clover.",
        gallery: [
          "/ejemplos/clover1.png",
          "/ejemplos/clover2.png",
          "/ejemplos/clover3.png"
        ]
      },
      {
        src: "/foto-2-01.png",
        title: "Desarrollo Web",
        desc: "Aplicaciones web modernas y escalables.",
        gallery: [
          "/ejemplos/web1.png",
          "/ejemplos/web2.png",
          "/ejemplos/web3.png"
        ]
      },
      {
        src: "/foto-3-01.png",
        title: "Aplicaciones Móviles",
        desc: "Apps móviles integradas con tus sistemas.",
        gallery: [
          "/ejemplos/mobile1.png",
          "/ejemplos/mobile2.png",
          "/ejemplos/mobile3.png"
        ]
      },
      {
        src: "/foto-1-01.png",
        title: "Automatización",
        desc: "Automatizamos procesos para optimizar tu negocio.",
        gallery: [
          "/ejemplos/auto1.png",
          "/ejemplos/auto2.png",
          "/ejemplos/auto3.png"
        ]
      },
      {
        src: "/whatsapp-image-2024-10-10-at-15.51.36.jpeg",
        title: "Tarjetas NFC",
        desc: "Presentación inteligente con NFC.",
        gallery: [
          "/ejemplos/nfc1.png",
          "/ejemplos/nfc2.png",
          "/ejemplos/nfc3.png"
        ]
      },
      {
        src: "/tdv-m256-04.png",
        title: "Sistema de Reservas",
        desc: "Para restaurantes, oficinas, estilistas y más.",
        gallery: [
          "/ejemplos/reservas1.jpg",
          "/ejemplos/reservas2.jpg"
        ]
      },
      {
        src: "/ivr.png",
        title: "Sistemas IVR Inteligentes",
        desc: "Flujos telefónicos con mensajes automáticos.",
        gallery: [
          "/ejemplos/ivr1.png",
          "/ejemplos/ivr2.png",
          "/ejemplos/ivr3.png"
        ]
      },
      {
        src: "/salycome.png",
        title: "Sal y Come para Clover",
        desc: "App nativa que integra menú, cupones y más.",
        gallery: [
          "/ejemplos/saly1.png",
          "/ejemplos/saly2.png",
          "/ejemplos/saly3.png"
        ]
      },
      
    ],
    form: {
        showText: "Agendar cita",
        hideText: "Cerrar formulario"
      },
    
      login: {
        text: "¿Ya eres cliente?",
        button: "Iniciar sesión"
      },
    
      calendar: {
        title: "Agenda una cita con nosotros",
        floatTitle: "Agendar cita"
      },
    
      
    
      whatsappFloat: {
        link: "https://wa.me/15558364840?text=Hola%20BBTS"
      },
      whatsappModal: {
        buttonText: "Hablar por WhatsApp"
      },
      theme: {
        primary: "#f97316",
        primaryDark: "#ea580c",
        accent: "#111827",
        gradientFrom: "#fff7ed",
        gradientTo: "#ffffff",
        highlight: "#ffedd5",
        cardBg: "#ffffff",
        cardBorder: "#f3f4f6"
      },

      animations: {
        hero: "fade-in",
        section: "fade-in-up",
        card: "slide-up"
      }
    
  };
  
  export default landingConfig;
  
